import { Base64 } from 'js-base64';

export default (message) => {
  if (!!window.isNativeApp && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(Base64.encode(JSON.stringify(message)));
  }
}